const Navigation = (sliderFn)=>{
	window.addEventListener('load', ()=>{
		function navSlide(slideNumber)
		{
			sliderFn.goToSlide('navSlider', slideNumber);
			navIcon.classList.add('active2');
		}

		const navIcon = document.getElementById('navigation-icon');
		const nav = document.getElementById('navigation');
		navIcon.addEventListener('click', ()=>{
			if(navIcon.classList.contains('active2') && nav.classList.contains('open'))
			{
				navIcon.classList.remove('active2');
				sliderFn.goToSlide('navSlider', 1);
			}
			else
			{
				window.location.href.includes('components') && navSlide(2);
				window.location.href.includes('modules') && navSlide(3);
				nav.classList.toggle('open');
				navIcon.classList.toggle('active');
			}
		});

		const navModules = document.getElementById('navModules');
		navModules && navModules.addEventListener('click', (e)=>{
			e.preventDefault();
			navSlide(3);
		});
		const navComponents = document.getElementById('navComponents');
		navComponents && navComponents.addEventListener('click', (e)=>{
			e.preventDefault();
			navSlide(2);
		});

		window.location.href.includes('components') && navSlide(2);
		window.location.href.includes('modules') && navSlide(3);
	})
}
export default Navigation;